export default __webpack_public_path__ + "static/media/dashboard2.a1db4746.png";